import { useAuthStore } from '@/stores'
import { createGlobalState, useSessionStorage } from '@vueuse/core'
import { computed } from 'vue'

export const useAppState = createGlobalState(() => {
  const envFrontend = new URL(window.location.origin) // import.meta.env.BASE_URL
  const envBackend = new URL(__BACKEND_URL__)
  const backendUrl = useSessionStorage<URL>('backend-url', envBackend, {
    listenToStorageChanges: true,
    serializer: {
      read: (raw: string): URL => new URL(raw),
      write: (value: URL): string => value.toString()
    }
  })
  const backendUrlNonDefault = computed(() => {
    if (import.meta.env.PROD) return false //never show in PROD
    const defBe = envBackend
    const curBe = backendUrl.value
    return defBe.toString() != curBe.toString()
  })
  const resetBackend = async () => {
    await setBackend(__BACKEND_URL__)
  }
  const setBackend = async (newBackend: string) => {
    backendUrl.value = new URL(newBackend)
    try {
      await useAuthStore().logout()
    } catch {
      /*NoOp*/
    }
    window.location.reload()
  }
  return { envFrontend, backendUrl, backendUrlNonDefault, resetBackend, setBackend }
})
